var React = require('react');

function Cheeseburger (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M58.6 224h394.7c34.6 0 54.6-43.9 34.8-75.9C448 83.2 359.5 32.1 256 32c-103.5.1-192 51.2-232.2 116.1-19.8 32 .3 75.9 34.8 75.9zM384 112a16 16 0 1 1-16 16 16 16 0 0 1 16-16zM256 80a16 16 0 1 1-16 16 16 16 0 0 1 16-16zm-128 32a16 16 0 1 1-16 16 16 16 0 0 1 16-16zm352 272H32a16 16 0 0 0-16 16v16a64.06 64.06 0 0 0 64 64h352a64.06 64.06 0 0 0 64-64v-16a16 16 0 0 0-16-16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M512 304a48 48 0 0 1-48 48H48a48 48 0 0 1 0-96h176l96 64 96-64h48a48 48 0 0 1 48 48z","className":"fa-primary","key":2})]);
}

Cheeseburger.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Cheeseburger;

Cheeseburger.default = Cheeseburger;
